import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../../DefaultNotification';

export interface IPlanApprovalRequestedNotificationProps extends IDefaultNotificationProps {
  company_id?: string;
  approval_id?: string;
  plan_id?: string;
  plan_name?: string;
  justification?: string;
  requested_at?: string;
}

function PlanApprovalRequestedNotification({
  plan_name,
  justification,
  created_at,
  isOpen,
  ...notification
}: IPlanApprovalRequestedNotificationProps) {
  return (
    <div className="flex flex-col flex-1">
      {isOpen && plan_name && (
        <div className="mb-2">
          <small className="font-semibold text-[rgba(59,58,52,0.9)]">
            Plano: {plan_name}
          </small>
          {justification && (
            <p className="text-xs mt-1 text-[rgba(59,58,52,0.7)] italic">
              &quot;{justification}&quot;
            </p>
          )}
        </div>
      )}
      <DefaultNotification
        {...notification}
        created_at={created_at}
        isOpen={isOpen}
      />
    </div>
  );
}

export default PlanApprovalRequestedNotification;
